// extracted by mini-css-extract-plugin
export var actualite = "detailsActu-module--actualite--60b01";
export var actualiteContentFooter = "detailsActu-module--actualite-content-footer--dc2d3";
export var actualiteContentFooterAuthor = "detailsActu-module--actualite-content-footer-author--ea85a";
export var actualiteContentFooterBack = "detailsActu-module--actualite-content-footer-back--89f27";
export var actualiteContentFooterDate = "detailsActu-module--actualite-content-footer-date--e5753";
export var actualiteContentFooterRight = "detailsActu-module--actualite-content-footer-right--94e25";
export var actualiteImg = "detailsActu-module--actualite-img--e955d";
export var actualiteTags = "detailsActu-module--actualite-tags--fba0b";
export var actualiteTaxo = "detailsActu-module--actualite-taxo--81e0c";
export var actualiteTitle = "detailsActu-module--actualite-title--c8452";
export var pageActu = "detailsActu-module--page-actu--c728c";
export var pageActuAdditionalInfos = "detailsActu-module--page-actu-additional-infos--ea65b";
export var socialPanelContainer = "detailsActu-module--social-panel-container--64601";